import AppIcon from 'components/applications/AppIcon';
import GenericNotification from './GenericNotification';

interface InstallationMessageProps {
  notification: any;
  deleteNotification: (...args: any[]) => any;
  onClick: (...args: any[]) => any;
  isDeleting: boolean;
}

function InstallationMessage({ notification, deleteNotification, onClick, isDeleting }: InstallationMessageProps) {
  if (notification.custom === undefined || notification.base === undefined) {
    return null;
  }
  const title = notification.base.from_name || '';
  const description = notification.custom?.message || '';

  return (
    <GenericNotification
      icon={<AppIcon id={notification.base.from} width={30} />}
      title={title}
      description={description}
      notification={notification}
      deleteNotification={deleteNotification}
      isDeleting={isDeleting}
      onClick={onClick}
    />
  );
}

export default InstallationMessage;
